import { render, staticRenderFns } from "./CreateDocumentCompany.vue?vue&type=template&id=027b099e&scoped=true&"
import script from "./CreateDocumentCompany.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentCompany.vue?vue&type=style&index=0&id=027b099e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b099e",
  null
  
)

export default component.exports